module.exports = __webpack_public_path__ + "site/img/62.51ba84ab.jpg";